import { Colors, Intent, TextArea } from "@blueprintjs/core";

import { MobileActionPopup } from "@/components/pieces/popup/MobileActionPopup";

interface MobileNoteEditableProps {
  isNew: boolean;
  value: string;
  loading: boolean;
  onSave: () => void;
  onCancel: () => void;
  onChange: (value: string) => void;
}

export function MobileNoteEditable({
  isNew,
  value,
  loading,
  onSave,
  onCancel,
  onChange,
}: MobileNoteEditableProps) {
  const allowSave = !!value.trim();
  return (
    <>
      <MobileActionPopup
        actionDisabled={!allowSave}
        visible={true}
        actionText="Save"
        loading={loading}
        intent={Intent.PRIMARY}
        onCancel={onCancel}
        onAction={onSave}
        title={isNew ? "New Note" : "Update Note"}
        context={
          <TextArea
            style={{
              background: Colors.LIGHT_GRAY5,
              minHeight: "150px",
              maxHeight: "250px",
            }}
            fill={true}
            placeholder="New Notes"
            value={value}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            intent={Intent.PRIMARY}
            autoResize={true}
            autoFocus={true}
          />
        }
      />
    </>
  );
}
